import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DashboardFinancialData } from "@/types";
import { toast } from "react-toastify";
import { fetchDashboardFinancial } from "./thunks";

interface PaginatedDashboardFinancial {
  data: DashboardFinancialData[];
  total?: number;
  currentPage?: number;
  perPage?: number;
}

interface DashboardFinancialState {
  dashboardFinancial: PaginatedDashboardFinancial;
  loading: boolean;
  error: string | null;
}

const initialState: DashboardFinancialState = {
  dashboardFinancial: { data: [] },
  loading: false,
  error: null,
};

const DashboardFinancialSlice = createSlice({
  name: "dashboardFinancial",
  initialState,
  reducers: {
    clearDashboardFinancial: (state) => {
      state.dashboardFinancial = { data: [] };
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchDashboardFinancial.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchDashboardFinancial.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          const payload = action.payload;

          if (payload.totals && payload.compositions) {
            state.dashboardFinancial = {
              data: [payload],
            };
          }
          // Se vier paginado
          else if (Array.isArray(payload.data)) {
            // Dados não paginados
            state.dashboardFinancial = { data: payload.data };
          } else {
            // Dados paginados
            state.dashboardFinancial = {
              data: payload.data.data,
              total: payload.data.total,
              currentPage: payload.data.current_page,
              perPage: payload.data.per_page,
            };
          }
        },
      )
      .addCase(fetchDashboardFinancial.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
      });
  },
});

export const { clearDashboardFinancial } = DashboardFinancialSlice.actions;
export default DashboardFinancialSlice.reducer;
